import React from "react"
import { chakra, Box } from "@chakra-ui/react"
import COLORS from "../../theme/colors"

const SwitchRound = ({ borderColor = "", colorCode, isDisabled, onClick }) => {
  const colors = [
    COLORS.white, // 0
    COLORS.red[500], // 1
    COLORS.grey[900], // 2
  ]
  return (
    <chakra.button
      type="button"
      onClick={isDisabled ? null : onClick}
      position="relative"
      top="4px"
      h="16px"
      w="16px"
      border={
        borderColor !== "" ? `1px solid ${borderColor}` : "1px solid gray"
      }
      borderRadius="50%"
      display="inline-block"
      cursor={onClick === undefined || isDisabled ? "default" : "pointer"}
      textAlign="left"
      outline="none"
    >
      <Box
        h="10px"
        w="10px"
        position="relative"
        top="-5px"
        left="2px"
        bg={colors[colorCode]}
        borderRadius="50%"
        display="inline-block"
      ></Box>
    </chakra.button>
  )
}

export default SwitchRound
